import { createBrowserHistory } from 'history';

// eslint-disable-next-line no-undef
export const pageTransfer = createBrowserHistory({ basename: '/' });
